module.exports = __webpack_public_path__ + "static/media/flotador-01.4e51e925.png";